import axios              from 'axios'
import {useLoadingStore}  from "@/stores/loading";
import {useAuthStore}     from "@/stores/auth";

export const urls = {
    diagnosis: {
        protocol : '/api/diagnosis/protocolList',
        result   : '/api/diagnosis/resultList',
    },
    presc: {
        list: '/api/presc/getList',
    },
    login:{
        login        : `/api/login/login`,
        logout       : `/api/login/logout`,
        userInfo     : `/api/login/userInfo`,
        refresh      : `/api/login/refresh`,
        checkEmail   : `/api/login/checkEmail`,
        checkID      : `/api/login/checkID`,
        register     : `/api/login/register`,
        findID       : `/api/login/findID`,
        findPassword : `/api/login/findPassword`,
    },
    account:{
        activityLog      : '/api/account/activityLog',
        userSearch       : '/api/account/AccountSearch',
        userData         : `/api/account/AccountData`,
        userList         : `/api/account/AccountList`,
        userUpdate       : `/api/account/updateStatus`,
        userDelete       : `/api/account/AccountDelete`,
        modify           : `/api/account/AccountModify`,
        register         : `/api/account/AccountRegister`,
        hospitalSearch   : '/api/account/hospitalSearch',
        hospitalList     : '/api/account/hospitalList',
        hospitalDelete   : '/api/account/hospitalDelete',
        hospitalModify   : `/api/account/hospitalModify`,
        hospitalRegister : `/api/account/hospitalRegister`,
        checkCode        : `/api/account/checkCode`,
    },
    system:{
        accessSave      : `/api/system/updateAccessAuthentication`,
        accessData      : `/api/system/accessAuthenticationdata`,
        apiKeyData      : `/api/system/apiKey`,
        apiKeyDelete    : `/api/system/deleteAPIKey`,
        apiKeyUpdate    : '/api/system/updateAPIKey',
        apiKeyInsert    : '/api/system/insertAPIKey',
        tokenData       : `/api/system/token`,
        tokenDelete     : `/api/system/deleteToken`,
        tokenUpdate     : '/api/system/updateToken',
        tokenInsert     : '/api/system/insertToken',
        deviceSearch    : '/api/system/deviceSearch',
        deviceList      : '/api/system/deviceList',
        deviceDelete    : `/api/system/deviceDelete`,
        deviceModify    : `/api/system/deviceModify`,
        deviceRegister  : `/api/system/deviceRegister`,
        deviceLogData   : `/api/system/deviceLogList`,
        deviceLogSearch : `/api/system/deviceLogSearch`,
    },
    menu: {
        list   : '/api/menu/getList',
        insert : '/api/menu/insert',
        update : '/api/menu/update',
        delete : '/api/menu/delete',
    },
    log: {
        userlist       : '/api/log/userlist',
        eventlist      : '/api/log/eventlist',
        userLogSearch  : '/api/log/userLogSearch',
        eventLogSearch : '/api/log/eventLogSearch',
        adminList      : '/api/log/adminList',
        adminLogSearch : '/api/log/adminLogSearch',
    },
    mypage:{
        mypageData  : `/api/mypage/mypageData`,
        modify      : `/api/mypage/modify`,
    }
}

const api = axios.create({
  withCredentials: true, 
})

// 인터셉터 설정
api.interceptors.request.use(
  (config) => {
    useLoadingStore().show()
    const token = localStorage.getItem('accessToken')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => {
    useLoadingStore().hide()
    return Promise.reject(error)
  }
)

// response: 로딩 hide + 토큰 갱신 헤더 처리 + 403 로그아웃
api.interceptors.response.use(
  (response) => {
    useLoadingStore().hide()

    // 서버가 응답헤더로 새 토큰 내려주는 케이스 처리(기존 로직 유지)
    if (response.headers['x-token-expired'] === 'true' || response.headers['x-token-refreshed'] === 'true') {
      const newToken = response.headers['authorization']?.replace('Bearer ', '')
      if (newToken) useAuthStore().setToken(newToken)
    }
    return response
  },
  (error) => {
    useLoadingStore().hide()
    if (error.response?.status === 403) useAuthStore().logout()
    return Promise.reject(error)
  }
)

export default api